import { Component, OnInit, OnDestroy } from '@angular/core';
import { PatientFacade } from '@cigna/chcp/patient/shared/data-access';
import { UserFacade } from '@cigna/chcp/shared/user-profile-data-access';
import { RouterFacade } from '@cigna/core/router-state';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'cigna-patient',
  templateUrl: './patient.component.html',
  styleUrls: ['./patient.component.scss'],
})
export class PatientComponent implements OnInit, OnDestroy {
  url$ = this.routerFacade.url$;
  onDestroy$ = new Subject();

  constructor(
    private patientFacade: PatientFacade,
    private userFacade: UserFacade,
    private routerFacade: RouterFacade,
  ) {}

  ngOnInit() {
    this.userFacade.getFlaggedPatients();
    this.url$.pipe(takeUntil(this.onDestroy$)).subscribe((url: string) => {
      this.patientFacade.resetErrors();
    });
  }

  ngOnDestroy() {
    this.patientFacade.setToInitialState();
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
